import * as React from "react"
import { useNavigate } from "react-router-dom"

import { UpgradeModal } from "@/components/ui/upgrade-modal"
import { UpgradePromptContext } from "@/providers/upgrade-prompt-context"

export function UpgradePromptProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const [feature, setFeature] = React.useState("")

  const openUpgrade = React.useCallback((featureMessage: string) => {
    setFeature(featureMessage)
    setOpen(true)
  }, [])

  const close = React.useCallback(() => {
    setOpen(false)
  }, [])

  const onUpgrade = React.useCallback(() => {
    navigate("/contact")
  }, [navigate])

  const value = React.useMemo(() => ({ openUpgrade, close }), [openUpgrade, close])

  return (
    <UpgradePromptContext.Provider value={value}>
      {children}
      <UpgradeModal
        open={open}
        onClose={close}
        onUpgrade={onUpgrade}
        feature={feature}
      />
    </UpgradePromptContext.Provider>
  )
}
